import React, { useContext, useEffect } from "react";
import { ExpandIcon, Hover } from "../PageExpand/style";
import { LanguageContext } from "../../core/store";

const PageExpand = () => {
    const { translate, fullscreen, handleFullscreenChange } = useContext(LanguageContext);

    const elem = document.documentElement;

    const handleFullscreen = () => {
        const newFullscreenState = !fullscreen;
        handleFullscreenChange(newFullscreenState);
        if (newFullscreenState) {
            if (elem.requestFullscreen) elem.requestFullscreen();
            else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
            else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
            else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
        } else {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
        }
    };

    useEffect(() => {
        const onFullscreenChange = () => {
            const isFullscreenActive = !!document.fullscreenElement;
            handleFullscreenChange(isFullscreenActive);
        };
        document.addEventListener("fullscreenchange", onFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", onFullscreenChange);
        };
    }, [handleFullscreenChange]);

    return (
        <ExpandIcon onClick={handleFullscreen} fullscreen={fullscreen}>
            <Hover>{fullscreen ? translate("utils.fullScreenOut") : translate("utils.fullScreenIn")}</Hover>
        </ExpandIcon>
    );
};

export default PageExpand;
